import { render, staticRenderFns } from "./ViolationDeleteAnswerCancel.vue?vue&type=template&id=4defd7f9&"
import script from "./ViolationDeleteAnswerCancel.vue?vue&type=script&lang=ts&"
export * from "./ViolationDeleteAnswerCancel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports